<template>
  <b-modal v-model="isOpen" title="Nota Fiscal" hide-footer>
    <b-form @submit.prevent="saveInvoice">
      <labeled-input id="invoice" v-model="invoice.number" label="Número da Nota Fiscal"/>
      <label v-if="!isPaid" class="mr-auto d-inline-block pointer link-like" v-b-tooltip="'Anexar nota fiscal'">
        {{ invoice.file || invoice.filePath ? 'Substituir nota fiscal' : 'Anexar nota fiscal' }}
        <file-input @input="onFileInput" hidden/>
      </label>
      <span v-if="!invoice.filePath && invoice.file" class="file-name">{{invoice.file.name}}</span>
      <a v-else-if="invoice.filePath" class="file-name" href="#" @click.prevent="downloadfile(invoice.filePath)">
        {{baseFileName(invoice.filePath)}}
      </a>
      <b-button save-button v-if="isAuthorized" type="submit">Salvar</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import AccountabilityService from '../../service/AccountabilityService';
import ServiceOrderService from '../../service/ServiceOrderService';
import StorageService from '../../service/StorageService';
import { alerter, requestAction, downloadFile, baseFileName } from '../../utils';
import FileInput from '../shared/FileInput.vue'
import { AccountabilityStatus } from '../../enums/AccountabilityStatus';

export default {
  components: { FileInput },
  data() {
    return {
      isOpen: false,
      service: new AccountabilityService(),
      serviceOrderService: new ServiceOrderService(),
      storageService: new StorageService(),
      accountability: {},
    };
  },
  computed: {
    invoice() {
      return this.accountability.invoice || { number: null, file: null };
    },
    isAuthorized(){
      return this.accountability.status && this.accountability.status.id === AccountabilityStatus.AUTHORIZED.id;
    },
    isPaid(){
      return this.accountability.status && this.accountability.status.id === AccountabilityStatus.PAID.id;
    }
  },
  methods: {
    open(accountability) {
      accountability.invoice = accountability.invoice || { number: null, file: null };
      this.accountability = accountability;
      this.isOpen = true;
    },
    baseFileName,
    async saveInvoice() {
      if (!this.invoice.number)
        return alerter.warn("Preencha o número da nota fiscal");
      if (!this.invoice.file && !this.invoice.filePath)
        return alerter.warn("Forneça o anexo da nota fiscal");

      let success = "Nota fiscal salva com sucesso";
      let failure = "Falha ao salvar nota fiscal";
      let accountability = await requestAction(success, failure, () => this.service.saveInvoice(this.accountability.id, this.invoice));
      this.accountability.invoice = accountability.invoice;
    },
    downloadfile(filePath) {
			return downloadFile(filePath, path => this.storageService.downloadFile(path));
		},
    onFileInput(file) {
      this.invoice.file = file;
      this.invoice.filePath = null;
    }
  },
}
</script>

<style scoped>
[save-button] {
  display: block;
  margin-left: auto;
}

.pointer {
  cursor: pointer;
}

.link-like {
  text-decoration: underline !important;
}

.file-name {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/os/Invoice.vue